import React, { useState } from 'react';
import { Button, Stack } from '@mui/material';
import { UnlockIcon } from '../../../icons'; // Custom Unlock Icon import

const WeekdayToggleButtons = () => {
  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  // Set default active days: Sun, Mon, Tue
  const defaultActiveDays = ['Sun', 'Mon', 'Tue'];

  const [states, setStates] = useState(
    weekdays.reduce((acc, day) => {
      acc[day] = { active: defaultActiveDays.includes(day) }; // ✅ Default active
      return acc;
    }, {})
  );

  const handleToggle = (day) => {
    setStates((prev) => ({
      ...prev,
      [day]: { active: !prev[day].active }
    }));
  };

  return (
    <Stack direction="row" spacing={1}>
      {weekdays.map((day) => {
        const { active } = states[day];
        return (
          <Button
            key={day}
            variant={active ? 'contained' : 'outlined'}
            onClick={() => handleToggle(day)}
            sx={{
              minWidth: 60,
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              borderRadius: '50px',
              borderColor: active ? '#0076FE' : '#F3F4F6',
              background: active ? '#0076FE' : '#F3F4F6',
              color: active ? '#fff' : '#606060',
              textTransform: 'capitalize',
              fontSize: '14px',
            }}
          >
            {day}
            <UnlockIcon sx={{ ml: 1, minWidth: '20px' }} />
          </Button>
        );
      })}
    </Stack>
  );
};

export default WeekdayToggleButtons;
